import {
  COUNTRY_CODE,
  SupportedCurrencyCountryMap
} from "@kivunova/kivufrontendcommon";

/**
 * Default ISO 4217 code when company or document currency is missing.
 * Uses Rwanda’s entry from {@link SupportedCurrencyCountryMap} when the common package
 * is fully loaded; falls back to `"RWF"` when tests mock `@kivunova/kivufrontendcommon`
 * without currency exports (avoids load-time crash).
 */
export const FALLBACK_CURRENCY_CODE =
  (COUNTRY_CODE &&
    SupportedCurrencyCountryMap &&
    SupportedCurrencyCountryMap[COUNTRY_CODE.RWANDA]?.code) ||
  "RWF";
